import { groupBy, map } from 'lodash'

function summarizeParticipantsDataByPlanNotificationServices(participantsData) {
  const participantsHash = groupBy(
    participantsData,
    (participant) => participant.mappedPlanName || participant.planName
  )

  return map(participantsHash, (records, planName) => {
    return {
      planName,
      participants: records.length,
    }
  })
}

export default summarizeParticipantsDataByPlanNotificationServices
